<template>
  <div>
    <modal opened="1" title="Título do modal" ref="modal">Conteúdo do modal</modal>

    <section class="main-content columns is-fullheight">
      <aside class="column is-2 is-paddingless" :class="{'active': menu_bars}">
        <div class="infobar">
          <div class=""> Dashboard </div>

          <div class="user-profile">
            <div class="user-profile-photo">
              <img src="../../assets/man.png" alt="man">
            </div>
            <div class="user-profile-data">
              <div class="name">{{this.$store.getters['user/getUserData'].nome}}</div>
              <!-- <div class="more-info">#35468</div> -->
            </div>
          </div>
        </div>

        <div class="menu-bars" @click="menu_bars=!menu_bars">
          <i class="fa" :class="(!menu_bars) ? 'fa-bars' : 'fa-times'"/>
        </div>

        <ul class="menu-list">
          <div @click="menu_bars=!menu_bars">
            <menu-item color="green" menuText="Início" link="/" icon="home"/>
          </div>

          <menu-item color="green" menuText="Associado" link="#" icon="user" submenu>
            <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Gerenciar Sócios" link="/gersocios"/>
            </div>
            <!-- <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Frequencias" link="/frequencias"/>
            </div> -->
            <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Mensalidades" link="/mensalidades"/>
            </div>
          </menu-item>

          <menu-item color="purple" menuText="Financeiro" icon="wallet" submenu>
            <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Receitas e Despesas" link="/recdesp"/>
            </div>
            <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Gerir Contas" link="/gercontas"/>
            </div>
            <!-- <div @click="menu_bars=!menu_bars">
              <menu-item menuText="Comprovantes" link="/comprovantes"/>
            </div> -->
          </menu-item>

          <!-- <menu-item color="red" menuText="Relatórios" link="#" icon="chart-pie" submenu>
            <menu-item menuText="Resumo Financeiro" link="/rsmfinanceiro"/>
            <menu-item menuText="Receitas e Despesas" link="/rltrecdesp"/>
          </menu-item> -->

          <!-- <menu-item color="blue" menuText="Diretoria" link="#" icon="user-tie" submenu>
            <menu-item menuText="Presidente" link="/financeiro"/>
            <menu-item menuText="Tesoureiro" link="/financeiro"/>
            <menu-item menuText="Secretário" link="/financeiro"/>
            <menu-item menuText="Conselho Fiscal" link="/financeiro"/>
          </menu-item> -->

          <!-- <menu-item color="purple" menuText="Configurações" link="#" icon="user-cog"/> -->

          <div @click="menu_bars=!menu_bars">
              <menu-item color="red" menuText="Sair" :action="logout" icon="sign-out-alt"/>
          </div>
        </ul>
      </aside>

      <div class="container section column is-10">
        <div class="level">
          <div class="level-left" :class="{'menu-bar-opened': menu_bars}">
            <div class="level-item notific-bar">
              <i class="fa fa-bell notific-item" ref="notific_item" @click.self="toggleNotific">
                <div class="notification-number">{{getNotifications}}</div>
              </i>

              <div class="notific-box" ref="notific_box">
                <div class="notific-box-item">caixinha legal</div>
              </div>
            </div>
            <div class="level-item">
              <div class="user">
                <i class="fa fa-user"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="control has-icons-right">
              <input class="input" type="text" placeholder="Buscar">
              <span class="icon is-right">
                <i class="fas fa-search"></i>
              </span>
            </div>
          </div>
        </div>

        <router-view/>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import "./src/css/views/Dashboard";
</style>

<script>
import MenuItem from "../../components/MenuItem";

export default {
  name: "Dashboard",
  components: { MenuItem },
  data() {
    return {
      menu_bars: false,
    };
  },

  computed: {
    getNotifications() {
      // let user = this.$store.state.user.userData;
      // if (user.associacoes) {
      //   let associacao = user.associacoes.filter(data => {
      //     return (data._associacao == this.$cookies.get("IDASSOCIACAO"));
      //   });
      //   return associacao.length
      // }
      return 0;
    }
  },

  methods: {
    openModal() {
      this.$refs.modal.openModal();
    },

    toggleNotific() {
      console.log(this.$refs.notific_box.classList);
      this.$refs.notific_item.classList.toggle("active");
      this.$refs.notific_box.classList.toggle("active");
    },

    logout() {
      this.$store.commit("associacao/setRequireUpdate", true);
      this.$store.dispatch("user/logout");
      this.$alert(
        "Deslogado com sucesso!",
        this.$store.getters["user/getUserData"].nome,
        "danger"
      );
    },
    parseJwt(token) {
      // The code and explication of this can be found in https://bit.ly/2O85B9z
      let base64Url = token.split(".")[1];
      let base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    }
  },
  mounted() {
    this.$store.dispatch("user/getUserDataInFirestore");
  }
};
</script>
